import { FUNNEL } from 'reporting-data/tsTypes/visualization';
import { getObjectType } from 'reporting-enablement/components/reportEditors/PipelineStageOrderEditor/journeyStageUtils';
import { CREATE_STAGE_ID } from 'reporting-enablement/components/reportEditors/PipelineStageOrderEditor/pipelineStageOrderEditorUtils';
import { getIsReportValidForChartType } from 'reporting-data/report/report-transformations/chartTypeTransformations';
const getDefaultPipelineStagesForObjectType = (pipelines, objectType) => {
  const defaultPipeline = pipelines && pipelines.find(pipeline => pipeline.objectType === objectType && pipeline.default);
  const initialPipeline = defaultPipeline || pipelines.find(pipeline => pipeline.objectType === objectType);
  return (initialPipeline === null || initialPipeline === void 0 ? void 0 : initialPipeline.stages) || [];
};
export const getDefaultPipelineSelectedStages = (template, pipelines) => {
  const journeyObjectType = getObjectType(template.toJS());
  const pipelineStages = getDefaultPipelineStagesForObjectType(pipelines, journeyObjectType) || [];
  const nonLostStages = pipelineStages.filter(stageData => {
    var _stageData$metadata, _stageData$metadata2;
    const probability = (_stageData$metadata = stageData.metadata) === null || _stageData$metadata === void 0 ? void 0 : _stageData$metadata.probability;
    const leadState = (_stageData$metadata2 = stageData.metadata) === null || _stageData$metadata2 === void 0 ? void 0 : _stageData$metadata2.leadState;
    if (!probability && !leadState) {
      return true;
    }
    return leadState && leadState !== 'UNQUALIFIED' || probability && Number(probability) > 0;
  });
  const selectedStages = nonLostStages.map((stageData, stageIndex) => {
    const optional = stageIndex !== nonLostStages.length - 1;
    return {
      pipelineObject: journeyObjectType,
      stageId: stageData.stageId,
      label: stageData.label,
      optional
    };
  });
  selectedStages.unshift({
    pipelineObject: journeyObjectType,
    stageId: CREATE_STAGE_ID,
    optional: false
  });
  return selectedStages;
};
export const getJourneyWithValidChartType = (report, scopes) => {
  const chartType = report.get('chartType');
  const isValidChartType = getIsReportValidForChartType(report, chartType, scopes);
  if (!isValidChartType) {
    return report.set('chartType', FUNNEL);
  }
  return report;
};